import React from 'react';
import { CTAButton } from './CTAButton';
export const Benefits = () => {
  return <div className="py-8 bg-green-50 rounded-lg p-8 my-8" data-id="element-54">
      <h2 className="text-3xl font-bold mb-8 text-center text-green-700" data-id="element-55">
        De viktigaste fördelarna vi upplevde med Nourix
      </h2>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-56">
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-57">
          <h3 className="text-xl font-semibold mb-3 text-green-700" data-id="element-58">
            Ökad energi
          </h3>
          <p className="text-lg" data-id="element-59">
            Redan efter några veckor märkte vi alla en tydlig skillnad i
            energinivå. Ingen eftermiddagströthet och mer ork att vara aktiv
            under hela dagen.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-60">
          <h3 className="text-xl font-semibold mb-3 text-green-700" data-id="element-61">
            Mindre sötsug
          </h3>
          <p className="text-lg" data-id="element-62">
            Det som förvånade mig mest var hur snabbt mitt sötsug minskade. Jag
            kunde plötsligt gå förbi godishyllan utan att känna ett
            tvångsmässigt behov av socker.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-63">
          <h3 className="text-xl font-semibold mb-3 text-green-700" data-id="element-64">
            Bättre matsmältning
          </h3>
          <p className="text-lg" data-id="element-65">
            Både jag och mamma märkte att vår matsmältning förbättrades. Mindre
            uppblåsthet och obehag efter måltider, och en mer regelbunden
            matsmältning.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-66">
          <h3 className="text-xl font-semibold mb-3 text-green-700" data-id="element-67">
            Hormonell balans
          </h3>
          <p className="text-lg" data-id="element-68">
            För mig personligen var den förbättrade hormonella balansen en stor
            vinst. Mina humörsvängningar minskade och jag kände mig mer stabil
            och harmonisk.
          </p>
        </div>
      </div>
      <div className="mt-10 text-center" data-id="element-69">
        <p className="text-lg mb-6 font-medium" data-id="element-70">
          Vill du också uppleva fördelarna med Nourix? Ta det korta quizet och
          se om Nourix kan vara rätt för dig!
        </p>
        <CTAButton text="Se om Nourix passar dig →" data-id="element-71" />
      </div>
    </div>;
};